function appendPerfilToOptionsIfMissing(setOptions, perfil) {
  if (!perfil?.id) return;
  setOptions((prev) =>
    prev?.some((o) => String(o.id) === String(perfil.id))
      ? prev
      : [...(prev || []), perfil]
  );
}

export { appendPerfilToOptionsIfMissing };
